// 2026-07-23 - FormuLearning - Lot 전환 동기화 스토어 (이슈 #50, P1 검증 피드백 F-8)
// 파일 위치: frontend/src/stores/lotStore.ts
// 목적: Step 3 탭과 Step 4 선택기가 활성 Lot을 서로 다른 컴포넌트에서 바꾸므로,
//       전환·생성·숨김이 일어나면 revision을 올려 양쪽이 서버 기준으로 재조회하게 한다.
//       (6개 Step 카드는 한 페이지에 동시 마운트 — 한쪽 변경이 다른 쪽에 자동 반영돼야 한다)

import { create } from 'zustand'

interface LotSyncState {
  /** Lot 구성·활성 Lot이 바뀔 때마다 증가. 구독자는 변경 시 서버 재조회한다. */
  revision: number
  bump: () => void
}

export const useLotSync = create<LotSyncState>((set) => ({
  revision: 0,
  bump: () => set((s) => ({ revision: s.revision + 1 })),
}))
